export const TrashCanIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2H6C6 1.44772 5.55228 1 5 1C4.44772 1 4 1.44772 4 2ZM3 2C3 0.89543 3.89543 0 5 0C6.10457 0 7 0.89543 7 2L9.5 2C9.77614 2 10 2.22386 10 2.5C10 2.77614 9.77614 3 9.5 3H9.05898L8.61576 8.1708C8.52709 9.20537 7.66143 10 6.62307 10H3.37693C2.33857 10 1.47291 9.20537 1.38424 8.1708L0.941024 3H0.5C0.223858 3 0 2.77614 0 2.5C0 2.22386 0.223858 2 0.5 2L3 2ZM6.5 5C6.5 4.72386 6.27614 4.5 6 4.5C5.72386 4.5 5.5 4.72386 5.5 5V7C5.5 7.27614 5.72386 7.5 6 7.5C6.27614 7.5 6.5 7.27614 6.5 7V5ZM4 4.5C4.27614 4.5 4.5 4.72386 4.5 5V7C4.5 7.27614 4.27614 7.5 4 7.5C3.72386 7.5 3.5 7.27614 3.5 7V5C3.5 4.72386 3.72386 4.5 4 4.5ZM2.38058 8.0854C2.42492 8.60268 2.85775 9 3.37693 9H6.62307C7.14225 9 7.57508 8.60269 7.61942 8.0854L8.05531 3H1.94469L2.38058 8.0854Z"
        fill="#B3B3B3"
      />
    </svg>
  )
}

export default TrashCanIcon
